import { useState } from 'react'
import { Outlet } from 'react-router'

import { Spinner } from '@/components/spinner'
import { AppVersion } from '@/components/version'

export function AuthLayout() {
  const [isLoading, setIsLoading] = useState(true)

  // The loading state is managed by the onCanPlayThrough callback of the video element.
  // This ensures that the loading spinner disappears as soon as the video is ready to play.
  return (
    <div className="relative flex min-h-screen select-none items-center justify-center bg-cover bg-center bg-no-repeat antialiased">
      {/* Video background with image fallback */}
      <div className="absolute inset-0 z-0 overflow-hidden">
        <video
          autoPlay
          loop
          muted
          playsInline
          poster="/videos/backgrounds/login/background.jpg"
          className="h-full w-full object-cover"
          onCanPlayThrough={() => setIsLoading(false)}
        >
          <source
            src="/videos/backgrounds/login/background.mp4"
            type="video/mp4"
          />
        </video>
      </div>

      {/* Loading spinner overlay */}
      {isLoading && (
        <div className="absolute inset-0 z-20 flex items-center justify-center bg-black/50">
          <Spinner className="h-12 w-12 text-white" />
        </div>
      )}

      {/* Content */}
      <div className="z-10">
        <Outlet />
      </div>

      <div className="absolute bottom-4 left-1/2 z-10 -translate-x-1/2">
        <AppVersion />
      </div>
    </div>
  )
}
